import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { ConfirmDialogService } from '../confirm-dialog/confirm-dialog-service';
export interface FormComponent {
   formg: UntypedFormGroup;
   hasChanged: boolean;
 }

@Injectable()
export class NavPreventerService  {

  constructor(
    private confirmDialogService: ConfirmDialogService  

  ) {
  }

  canDeactivate(component: FormComponent) {
    if(component.hasChanged){
      return confirm(
        'Biztos, hogy mentés nélkül el akarja hagyni a beviteli képernyőt?'
      );
    }
    return true;
   }
}